import React from 'react';
import {
  Box,
  Typography,
  LinearProgress
} from '@mui/material';
import { Card } from 'Components/Card'



const ProgressInfoCard = ({
                            title,
                            description,
                            icon,
                            value,
                            total,
                            progress,
                            color = '#0039c4',
                            iconBgColor = '#e3e9f8',
                            unitLabel = '% Linked',
                            sx = {}

                          }) => {
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        ...sx
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" alignItems="center" gap={1}>
          <Box sx={{ backgroundColor: iconBgColor, padding: 1, borderRadius: '50%' }}>
            {icon}
          </Box>
          <Box>
            <Typography variant="body1" fontWeight="bold" fontSize="0.95rem">
              {title}
            </Typography>
            <Typography variant="body2" color="gray" fontSize="0.75rem">
              {description}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box mt={1} display="flex" alignItems="center" gap={1}>
        <Typography variant="h5" fontWeight="bold">
          {value.toLocaleString()}
        </Typography>
        <Typography variant="body2" color="gray" fontSize="0.875rem">
          / {total.toLocaleString()}
        </Typography>
      </Box>

      <Box mt={1} display="flex" alignItems="center" gap={1} className="mb-0">
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            backgroundColor: '#EEE',
            height: 4,
            borderRadius: 3,
            width: '100%',
            '& .MuiLinearProgress-bar': {
              backgroundColor: color
            }
          }}
        />
        <Typography
          variant="body2"
          color="gray"
          fontSize="0.75rem"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {progress.toFixed(1)}{unitLabel}
        </Typography>
      </Box>
    </Card>
  );
};

export default ProgressInfoCard;
